<!-- <template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label><b>{{ label }}</b></v-label>
    <s-select-generic autocomplete class="text" itemvalue="CtgID" :disabled="disabled" :value="value" id="CtgID"
      itemtext="CtgDescription" :return-object="returnObject" @input="input($event)" :config="config" :full="full"
      :text="text" :clearable="clearable" :noDefault="noDefault" auto-select>
    </s-select-generic>
  </div>
</template> -->
<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label  v-if="!multiple"><b>{{ label }}</b></v-label>

    <!-- 🔹 MODO SIMPLE -->
    <template v-if="!multiple">
      <s-select-generic
        autocomplete
        class="text"
        itemvalue="CtgID"
        itemtext="CtgDescription"
        :disabled="disabled"
        :value="value"
        :return-object="returnObject"
        @input="input($event)"
        :config="config"
        :full="full"
        :text="text"
        :clearable="clearable"
        :noDefault="noDefault"
        auto-select
        id="CtgID"
      />
    </template>

    <!-- 🔹 MODO MULTIPLE -->
    <template v-else>
      <v-select
        multiple
        v-model="selected"
        :items="items"
        item-text="CtgDescription"
        item-value="CtgID"
        :return-object="returnObject"
        :label="label"
        :clearable="clearable"
        :disabled="disabled"
        hide-details
        @input="input($event)"
      >
        <!-- UX PRO -->
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 1" x-small color="teal" outlined>
            <span class="text-truncate" style="max-width: 120px;">
              {{ item.CtgDescription }}
            </span>
          </v-chip>

          <span v-else-if="index === 1" class="grey--text text--darken-1">
            +{{ selected.length - 1 }}
          </span>
        </template>
      </v-select>
    </template>

  </div>
</template>
<script>
import _sService from "@/services/Technicalassistance/ConfigurationPrice.js";
import { mounted } from "qrcode.vue";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    typeCultive: {
      type: Number,
      default: 0,
    },
    TypeDestiny: {
      type: Number,
      default: 0,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    produceID: {
      type: Number,
      default: 0,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // value(value) {
    //   this.item = value;
    // },
    value(val) {
      if (this.multiple) {
        this.selected = val || [];
      } else {
        this.item = val;
      }
    },
    produceID() {
      this.config.params.StatusID = this.produceID
      this.refreshParams();
    },
    typeCultive() {
      this.config.params.typeCultive = this.typeCultive;
      this.refreshParams();
    },
    TypeDestiny() {
      this.config.params.TypeDestiny = this.TypeDestiny
      this.refreshParams();
    },
    multiple(){
       this.refreshParams();
    }
  },
  methods: {
    // input(val) {
    //   this.$emit("input", val);
    // },
    input(val) {
      if (this.multiple) {
        this.$emit("input", val || []);
      } else {
        this.$emit("input", val);
      }
    },
    loadItems() {       
      try {       
        console.log("paramatros",this.config.params);
        this.$http.post(_sService.getUrllistPaymer(), {}, { params: this.config.params  }).then((r) => {    
          if (r.status == 200) {
            this.items = r.data;
            console.log("Data",r.data);                    
          }
        });    
      } catch (e) {
        console.error(e);
      }
    },
    refreshParams() {
      this.config.params = {
        ...this.config.params,
        StatusID: this.produceID,
        typeCultive: this.typeCultive,
        TypeDestiny: this.TypeDestiny
      };

      if (this.multiple) {
        this.loadItems();
      }
    }

  },
  data: () => ({
    item: 0,
    val: "",
    selected: [], // 🔥 para multiple
    items: [],
    config: {},
  }),

  created() {
    console.log('tipo calibre');
    console.log(this.typeCultive);
    console.log(this.TypeDestiny);
    // this.config = {
    //   url: _sService.getUrllistPaymer(),
    //   title: this.label,
    //   params: { search: " ", requestID: this.$fun.getUserID(), StatusID: 0, typeCultive: this.typeCultive, TypeDestiny: this.TypeDestiny },
    // };
    this.config = {
      url: _sService.getUrllistPaymer(),
      title: this.label,
      params: {
        search: " ",
        requestID: this.$fun.getUserID(),
        StatusID: 0,
        typeCultive: this.typeCultive,
        TypeDestiny: this.TypeDestiny
      },
    };

    if (this.multiple) {
      console.log("Cargaaaaaaa Multiple")
      this.loadItems(); // 🔥 solo si es múltiple
    }
  },
  mounted(){
     this.config = {
      url: _sService.getUrllistPaymer(),
      title: this.label,
      params: {
        search: " ",
        requestID: this.$fun.getUserID(),
        StatusID: 0,
        typeCultive: this.typeCultive,
        TypeDestiny: this.TypeDestiny,
      },
    };

    if (this.multiple) {
      this.loadItems();
    }
  }
};
</script>
